import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import httpClient from "common/api/httpClient";

export type Resource = {
  name: string;
};

type ResourcesCRUDState = {
  isLoading: boolean;
  error?: string;
  list: Resource[];
};

const initialState: ResourcesCRUDState = {
  isLoading: false,
  list: [],
};

export const getResources = createAsyncThunk(
  "developer/resourcesCRUD/getResources",
  async () => {
    const response = await httpClient.get<string[]>("Resources");
    return response.data;
  }
);

export const createResource = createAsyncThunk(
  "developer/resourcesCRUD/createResource",
  async (file: File) => {
    const formData = new FormData();
    formData.append("resource", file);
    await httpClient.post("Resources/resource", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return file.name;
  }
);

export const deleteResource = createAsyncThunk(
  "developer/resourcesCRUD/deleteResource",
  async (resourceName: string) => {
    await httpClient.delete(`Resources/${resourceName}`);
    return resourceName;
  }
);

export const developerResourcesCRUDSlice = createSlice({
  name: "developer/resourcesCRUD",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getResources.pending, (state) => {
      state.isLoading = true;
      state.error = "";
    });
    builder.addCase(getResources.fulfilled, (state, action) => {
      state.isLoading = false;
      state.list = action.payload.map((name: string) => ({
        name: name,
      }));
    });
    builder.addCase(getResources.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(createResource.pending, (state) => {
      state.isLoading = true;
      state.error = "";
    });
    builder.addCase(createResource.fulfilled, (state, action) => {
      state.isLoading = false;
      state.list.push({
        name: action.payload,
      });
    });
    builder.addCase(createResource.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(deleteResource.pending, (state) => {
      state.isLoading = true;
      state.error = "";
    });
    builder.addCase(deleteResource.fulfilled, (state, action) => {
      state.isLoading = false;
      const resourceName = action.payload;
      if (resourceName) {
        state.list = state.list.filter(
          (resource) => resource.name !== resourceName
        );
      }
    });
    builder.addCase(deleteResource.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});
